<template>
  <div class="draw fill-height" style="min-width: 50w">
    <div class="canvas d-flex mx-auto fill-height">
      <h2 v-bind:style="{ color: lineColor }" class="noselect" v-if="!undo">
        {{ $t(title) }}
      </h2>

      <svg xmlns=http://www.w3.org/2000/svg version="1.1" class="drawSvg
      fill-height" :width="canvasWidth" :height="canvasHeight"
      @mousedown="linestart()" @touchstart="linestart()" @mousemove="lineMove()"
      @touchmove="lineMove()" @mouseup="lineEnd()" @touchend="lineEnd()">
        <rect id="bg" width="100%" height="100%" v-bind:fill="bgColor" />
      </svg>

      <div id="cursor" v-bind:style="{ 'background-color': lineColor }"></div>
    </div>

    <v-speed-dial v-model="fab" bottom right absolute>
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab :loading="loading">
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <app-action-button fab dark small color="accent" @click="undoLine">
        mdi-undo
        <template #text>
          {{ $t('undo') }}
        </template>
      </app-action-button>
      <app-action-button fab dark small color="red" @click="clean">
        mdi-eraser
        <template #text>
          {{ $t('erase') }}
        </template>
      </app-action-button>
      <app-action-button fab dark small color="secondary" @click="send">
        mdi-send
        <template #text>
          {{ $t('send') }}
        </template>
      </app-action-button>
      <app-action-button fab dark small color="green" @click="download">
        mdi-download
        <template #text>
          {{ $t('download') }}
        </template>
      </app-action-button>
    </v-speed-dial>
  </div>
</template>

<script>
import './signature.css';
import ActionButton from '@/components/ActionButton.vue';
import { postSignature } from '@/api/Remittances/remittances.api';
import { urltoFile } from '@/utils/functions';

const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

export default {
  components: {
    appActionButton: ActionButton,
  },
  name: 'Draw',
  props: ['title', 'colors', 'bgColors', 'lineColor', 'bgColor'],
  data() {
    return {
      board: '',
      cursor: '',
      colorNum: 0,
      gesture: false,
      line: '',
      radius: 2.5,
      width: 8,
      undo: false,
      onCanvas: false, // mouseout event is not firing, dunno why
      fab: false,
      loading: false,
    };
  },

  computed: {
    small() {
      return this.$vuetify.breakpoint.xs;
    },

    canvasWidth: function() {
      return this.board.clientWidth;
    },

    canvasHeight: function() {
      return this.board.clientHeight;
    },
  },

  methods: {
    initBoard: function() {
      this.board = $('.drawSvg');
      this.cursor = $('#cursor');
      this.gesture = false;
    },

    linestart: function() {
      this.undo = true;

      const e = event;

      // this.line += 'M' + this.cursorX + ',' + this.cursorY
      // I prefer to use code above with computed valuse, but it drops some errors about setter, and I didn't succeed to solve it in 15 minutes.

      const rect = this.board.getBoundingClientRect();
      const cursorX =
        Math.round(e.clientX - rect.x) ||
        Math.round(e.changedTouches[0].clientX - rect.x);
      const cursorY =
        Math.round(e.clientY - rect.y) ||
        Math.round(e.changedTouches[0].clientY - rect.y);

      this.line += 'M' + cursorX + ',' + cursorY;

      this.cursor.style.opacity = 1;
      this.gesture = true;
      e.preventDefault();
    },

    lineMove: function() {
      try {
        const e = event;
        if (!e) return;

        const rect = this.board.getBoundingClientRect();

        const cursorX =
          Math.round(e.clientX - rect.x) ||
          Math.round(e.changedTouches[0].clientX - rect.x);
        const cursorY =
          Math.round(e.clientY - rect.y) ||
          Math.round(e.changedTouches[0].clientY - rect.y);

        if (this.gesture == true) {
          this.line += 'L' + cursorX + ',' + cursorY;
          // this.line += 'L'+(e.clientX||e.touches[0].clientX)+','+(e.clientY||e.touches[0].clientY)+' '
          this.trace(
            e.clientX || e.touches[0].clientX,
            e.clientY || e.touches[0].clientY,
          );
        }

        this.cursor.style.top = e.clientY - rect.y - this.radius + 'px';
        this.cursor.style.left = e.clientX - rect.x - this.radius + 'px';

        this.cursorX = e.clientX - rect.x;
        this.cursorY = e.clientY - rect.y;

        this.onCanvas = true;
      } catch (error) {
        console.log(error);
      }
    },

    trace: function(x, y) {
      const dot = document.createElement('div');
      dot.classList.add('dot');
      dot.style.top = y - this.radius + 'px';
      dot.style.left = x - this.radius + 'px';
      dot.style.background = this.lineColor;
      dot.style.width = dot.style.height = this.radius * 2 + 'px';
      document.body.appendChild(dot);
      setTimeout(function() {
        dot.style.opacity = 0;
      }, 500);
      setTimeout(function() {
        document.body.removeChild(dot);
      }, 1000);
    },

    lineEnd: function() {
      const e = event;
      const rect = this.board.getBoundingClientRect();

      const cursorX =
        Math.round(e.clientX - rect.x) ||
        Math.round(e.changedTouches[0].clientX - rect.x);
      const cursorY =
        Math.round(e.clientY - rect.y) ||
        Math.round(e.changedTouches[0].clientY - rect.y);

      this.line += 'L' + cursorX + ',' + cursorY;
      // this.line += 'L'+(e.clientX||e.changedTouches[0].clientX)+','+(e.clientY||e.changedTouches[0].clientY)
      this.cursor.style.opacity = 0.5;
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path',
      );
      path.setAttributeNS(null, 'd', this.line);
      path.setAttributeNS(null, 'fill', 'none');
      path.setAttributeNS(null, 'stroke-linecap', 'round');
      path.setAttributeNS(null, 'stroke-linejoin', 'round');
      path.setAttributeNS(null, 'stroke', this.lineColor);

      path.setAttributeNS(null, 'stroke-width', this.width);
      this.board.appendChild(path);
      // this.board.innerHTML = this.board.innerHTML // force SVG repaint after DOM change
      this.gesture = false;
      this.line = '';

      // saving to local storage
      // localStorage.svg = new XMLSerializer().serializeToString(this.board)
    },

    // For changing color positions inside toolbar
    arrayMove: function(arr, fromIndex, toIndex) {
      const element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },

    rgb2hex: function(rgb) {
      function hex(x) {
        return ('0' + parseInt(x).toString(16)).slice(-2);
      }
      if (rgb.search('rgb') == -1) {
        return rgb;
      } else {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
        return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
      }
    },

    setActiveColor: function(Li) {
      const allColors = $$(Li);
      const target = event.target; // for set time out

      for (const color of allColors) {
        color.classList.remove('activeColor');
      }

      setTimeout(function() {
        target.classList.add('activeColor');
      }, 10);
    },

    setActiveColorMounted: function(li, arr, color) {
      const allLi = $$(li);
      const colorIndex = arr.indexOf(color);

      for (const li of allLi) {
        const liColor = this.rgb2hex(li.style.backgroundColor).toUpperCase();

        if (liColor === color) {
          li.classList.add('activeColor');

          this.arrayMove(arr, colorIndex, 0);
        }
      }
    },

    changeLineColor(color, index) {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      this.$emit('changeLineColor', color);

      this.setActiveColor('.lineColor li');

      // changing circle position
      this.arrayMove(this.colors, index, 0);
    },

    changeBg(color, index) {
      // just change backgrounds colors one after another
      window.scrollTo({ top: 0, behavior: 'smooth' });

      this.$emit('changeBgColor', color);

      this.setActiveColor('.bgColor li');

      $('.drawSvg #bg').setAttribute('fill', this.bgColor);

      this.arrayMove(this.bgColors, index, 0);

      // this.board.innerHTML = this.board.innerHTML // force SVG repaint after DOM change
    },

    undoLine: function() {
      const paths = $$('.drawSvg path');
      $('.drawSvg').removeChild(paths[paths.length - 1]);
    },

    clean: function() {
      this.line = '';
      this.undo = false;

      const paths = $$('.drawSvg path').length;

      let i = 0;

      for (i = 0; i < paths; i++) {
        this.board.removeChild(this.board.querySelectorAll('path')[0]);
      }

      // this.board.innerHTML = ''; more effective, but removes bg also
    },

    download: function() {
      const dl = document.createElement('a');
      const drawing = this.svgDataURL($('.drawSvg'));
      document.body.appendChild(dl); // This line makes it work in Firefox.
      dl.setAttribute('href', drawing);
      dl.setAttribute('download', 'freehand-svg-drawing.svg');
      dl.click();
    },

    svgDataURL: function() {
      // let drawSvg = new XMLSerializer().serializeToString(this.board)
      const serialSvg = new XMLSerializer().serializeToString(this.board);
      return 'data:image/svg+xml,' + encodeURIComponent(serialSvg);

      // this.$emit('drawSubmit', drawSvg);
    },
    async send() {
      this.loading = true;
      try {
        const drawing = this.svgDataURL($('.drawSvg'));
        const file = await urltoFile(drawing, 'signature.svg', 'image/svg+xml')

        await postSignature({
          signature: this.$route.params.uuid,
          image: file,
        });
        this.$emit('sent', false);
      } catch {
        this.$emit('sent', true);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted: function() {
    this.initBoard();

    this.colors;

    this.setActiveColorMounted('.lineColor li', this.colors, this.lineColor);
    this.setActiveColorMounted('.bgColor li', this.bgColors, this.bgColor);
  },
};
</script>
